module.exports = __webpack_public_path__ + "img/1SSMNorte.c8aede6b.jpg";